import { translations } from '../translations';

export const useTranslation = () => {
  const t = (key: keyof typeof translations) => {
    return translations[key] || key;
  };

  return { t };
};
